import { Locale, format } from "date-fns";

import { AssignmentResponse } from "@/api";

export function formatAssignmentDueDate(assignment: AssignmentResponse, locale?: Locale): string {
  return format(assignment.dueDate, "P", { locale });
}
